export type UiColorScale = {
  0: string;
  1: string;
  2: string;
  3: string;
  4: string;
  5: string;
  6: string;
  7: string;
  8: string;
  9: string;
};

export type UiTokens = {
  typography: {
    body: string;
    display: string;
    monospace: string;
    size: {
      xs: number;
      sm: number;
      md: number;
      lg: number;
      xl: number;
      xxl: number;
    };
    weight: {
      regular: number;
      medium: number;
      semibold: number;
      bold: number;
    };
  };
  spacing: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl: number;
    xxl: number;
  };
  radius: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl: number;
  };
  elevation: {
    sm: string;
    md: string;
    lg: string;
  };
  motion: {
    fast: string;
    normal: string;
    slow: string;
  };
  color: {
    ember: UiColorScale;
    gunmetal: UiColorScale;
  };
};

export const uiTokens: UiTokens = {
  typography: {
    body: 'DM Sans, sans-serif',
    display: 'Oswald, sans-serif',
    monospace: 'JetBrains Mono, monospace',
    size: { xs: 12, sm: 14, md: 16, lg: 18, xl: 22, xxl: 28 },
    weight: { regular: 400, medium: 500, semibold: 600, bold: 700 }
  },
  spacing: { xs: 4, sm: 8, md: 16, lg: 24, xl: 40, xxl: 56 },
  radius: { xs: 6, sm: 8, md: 12, lg: 16, xl: 24 },
  elevation: {
    sm: '0 1px 2px rgba(0,0,0,0.12)',
    md: '0 6px 18px rgba(0,0,0,0.18)',
    lg: '0 14px 28px rgba(0,0,0,0.24)'
  },
  motion: {
    fast: '120ms ease',
    normal: '180ms ease',
    slow: '260ms ease'
  },
  color: {
    ember: {
      0: '#FFF0E6',
      1: '#FFD4B3',
      2: '#FFB380',
      3: '#FF924D',
      4: '#FF7120',
      5: '#E85D04',
      6: '#C44D03',
      7: '#A03D02',
      8: '#7C2E01',
      9: '#581F01'
    },
    gunmetal: {
      0: '#F0F3F7',
      1: '#D8DEE6',
      2: '#B0BCC9',
      3: '#8899AC',
      4: '#60768F',
      5: '#3D5472',
      6: '#1A3A5C',
      7: '#142D48',
      8: '#0D2035',
      9: '#071220'
    }
  }
}

export const px = (value: number): string => `${value}px`
